// Source unique des questions/réponses de la FAQ Velko Bar.
// Réutilisée par BarFaqV2 (rendu accordéon) ET par Bar.tsx pour générer le
// JSON-LD FAQPage. Les réponses sont en texte simple pour que le contenu du
// schéma corresponde EXACTEMENT au contenu visible (exigence Google), et pour
// rester citable par les moteurs IA (GEO).

export type BarFaqEntry = { q: string; a: string };

export const BAR_FAQ: ReadonlyArray<BarFaqEntry> = [
  {
    q: 'Qu’est-ce que le pour cost (coût de revient d’une boisson) ?',
    a: 'Le pour cost, c’est le coût des ingrédients d’une boisson divisé par son prix de vente, exprimé en pourcentage. Exemple : un Mojito qui coûte 821 F à produire et se vend 4 000 F a un pour cost de 21 %. Velko Bar calcule ce pour cost automatiquement à partir de ta recette décimale (50 ml de rhum, 30 ml de citron…) et du coût par millilitre de chaque ingrédient.',
  },
  {
    q: 'Comment Velko Bar calcule-t-il l’écart de stock (théorique vs réel) ?',
    a: 'À chaque vente, Velko décompte du stock les ingrédients de la recette : c’est le stock théorique. En fin de service, ton équipe compte le stock réel à l’aveugle. Velko compare les deux et chiffre l’écart en millilitres, en pourcentage et en francs CFA, ingrédient par ingrédient. Tu vois exactement ce qui fuit (surdosage, coulage, vol) et combien ça te coûte.',
  },
  {
    q: 'Velko Bar fonctionne-t-il sans connexion internet ?',
    a: 'Oui. Le contrôle des coûts boissons fonctionne hors ligne, au comptoir. Les ventes déduisent la consommation et les comptages sont enregistrés même sans réseau ; tout se synchronise automatiquement dès que la connexion revient. C’est pensé pour les bars et restaurants d’Afrique où le réseau n’est pas toujours fiable.',
  },
  {
    q: 'Dois-je changer ma caisse pour utiliser Velko Bar ?',
    a: 'Non. Velko Bar n’est pas un logiciel à part : c’est un module qui s’active dans la caisse Velko que tu utilises déjà. Tes ventes classiques ne changent pas ; tu ajoutes simplement les recettes et le suivi des coûts par-dessus, quand tu es prêt.',
  },
  {
    q: 'Velko Bar convient-il à un maquis, un snack ou un lounge ?',
    a: 'Oui. Velko Bar s’adresse à tout établissement qui sert des boissons : bar, lounge, maquis, snack-bar, restaurant, hôtel. Dès que tu vends des cocktails, des bières, des vins ou des spiritueux au verre, le contrôle des coûts et la détection du surdosage te font gagner de la marge.',
  },
  {
    q: 'Comment l’inventaire à l’aveugle empêche-t-il la triche ?',
    a: 'Dans un comptage à l’aveugle (blind count), la personne qui compte ne voit pas le stock théorique attendu. Impossible donc d’« arranger » les chiffres pour qu’ils tombent juste. Les données saisies sont le reflet réel du stock, ce qui rend l’écart fiable et l’analyse crédible.',
  },
  {
    q: 'Combien coûte Velko Bar ?',
    a: 'Velko Bar est un module premium qui s’active sur ton abonnement Velko. Le détail des offres et des prix en francs CFA est sur la page Tarifs. Tu peux commencer gratuitement et activer le contrôle bar quand ton activité le justifie.',
  },
];

/** Génère le bloc JSON-LD FAQPage à partir des entrées ci-dessus. */
export function barFaqJsonLd(): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: BAR_FAQ.map(({ q, a }) => ({
      '@type': 'Question',
      name: q,
      acceptedAnswer: { '@type': 'Answer', text: a },
    })),
  };
}
